import { render, staticRenderFns } from "./ProposalVariantFilters.vue?vue&type=template&id=6dc45978"
import script from "./ProposalVariantFilters.vue?vue&type=script&lang=js"
export * from "./ProposalVariantFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports